import { platformClient } from './platform.client';
import type { MyFeatureAccessResponse } from '../types/featureAccess';

export const getMyFeatureAccess = async (): Promise<MyFeatureAccessResponse> => {
  const response = await platformClient.get<MyFeatureAccessResponse>('/platform/feature-access/me');
  return response.data;
};
